<template>
    <div class="coupon-popup-bg" v-if="isLoaded">
        <div class="coupon-popup">
            <a href="#" class="coupon-popup__close" @click.prevent="closeCouponPopup"><span class="fa fa-times" title="Close Coupon Details"></span></a>
            <div class="coupon-popup__title">Related Coupon</div>
            <img v-bind:src="coupon.imageUrl" class="coupon-image" alt>

            <div class="coupon-popup__bubblecallout">
                {{coupon.bubbleCallOut}}
            </div>
            <p v-html="coupon.displayName">
            </p>

            <div v-show="coupon.unclipped">
                <button class="btn btn-full-width btn-coupon mb-3" @click="clipCoupon(coupon.couponId)" aria-label="Clip Coupon"><i class="fa fa-scissors" aria-hidden="true"></i> Clip</button>
            </div>

            <div v-show="!coupon.unclipped">
                <button class="btn btn-full-width btn-coupon btn-coupon-clipped btn-disabled mb-3"><i class="fa fa-scissors" aria-hidden="true"></i> Clipped</button>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'ProductCardCouponPopup',
  props: {
    couponId: {
      type: String,
      required: true
    }
  },
  components: {},
  data () {
    return {
      isLoaded: false,
      weight: 0,
      coupon: {}
    }
  },
  computed: {
  },
  methods: {
    clipCoupon () {
      if(!window.heb.data.user.isGuest){
        this.gtmClickCoupon('e_selectCoupon', this.coupon, 1)
        this.$store.dispatch('cart/CLIP_COUPON', {couponId: this.couponId}).then((response) => {
          if(response.status === 200){
            // refresh local coupon data to show clipped
            this.coupon = response.data
          }
        })
      }else{
        window.location = '/my-account/login';
      }
    },
    getCouponDetails: function () {
      var vm = this
      axios
        .all([axios.get('/commerce-api/v1/coupon/details/' + this.couponId)])
        .then(
          axios.spread(response => {
            vm.isLoaded = true
            vm.coupon = response.data
          })
        )
        .catch((error) => {
          // silently fail
          vm.isLoaded = true
          this.closeCouponPopup();
        })
    },
    closeCouponPopup () {
      this.$emit('closeCouponPopup')
    }
  },
  mounted: function () {
    this.getCouponDetails()
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "../../assets/lib";
@import "../../../../static-assets/css/_btn.scss";

.coupon-popup-bg {
  position: absolute;
  background-color: rgba(0, 0, 0, 0.25);
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  padding: 1px;
  border-radius: $border-radius-standard;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  z-index: 10;
}

.coupon-popup {
  background-color: #fff;
  border-radius: $border-radius-standard;
  text-align: center;
  padding: 4px;
  position: relative;

  &__bubblecallout{
      color: red;
      font-weight: 600;
  }

  &__title {
    font-weight: 600;
  }

  .coupon-popup__close{
      cursor: pointer;
      position: absolute;
      right: 8px;
      top: 2px;
      color: $color-heb-primary;
      font-size: 16px;
  }

  .coupon-image{
    max-height: 100px;
    margin: 0 auto;
  }
}
</style>
